module.exports = __webpack_public_path__ + "img/check_confirm.81dbb955.svg";